import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';

const CBMultiSelect = ({
  options = [], // Array of { label: string, value: any }
  selectedValues = [], // Array of values
  onChange, // Function called with array of selected values
  placeholder = 'Select...',
  label,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = (value) => {
    let newSelectedValues;
    if (selectedValues.includes(value)) {
      newSelectedValues = selectedValues.filter((v) => v !== value);
    } else {
      newSelectedValues = [...selectedValues, value];
    }
    onChange(newSelectedValues);
  };

  const getSelectedLabels = () => {
    if (selectedValues.length === 0) return placeholder;
    return options
      .filter((opt) => selectedValues.includes(opt.value))
      .map((opt) => opt.label)
      .join(', ');
  };

  const removeSelectedValue = (value, event) => {
    event.stopPropagation(); // Prevent dropdown from opening/closing
    const newSelectedValues = selectedValues.filter((v) => v !== value);
    onChange(newSelectedValues);
  };


  return (
    <div className={`relative ${className}`} ref={wrapperRef}>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:bg-brand_blue focus:border-brand_blue sm:text-sm"
      >
        <span className="block truncate">{getSelectedLabels()}</span>
        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <FontAwesomeIcon icon={faChevronDown} className="h-5 w-5 text-gray-400" />
        </span>
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-brand_blue hover:text-white"
            >
              <span className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedValues.includes(option.value)}
                  readOnly // Click handled by div
                  className="mr-3 h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer"
                />
                <span className="font-normal block truncate">
                  {option.label}
                </span>
              </span>
            </div>
          ))}
           {options.length === 0 && (
             <div className="cursor-default select-none relative py-2 px-3 text-gray-500">
               No options available
             </div>
           )}
        </div>
      )}
       {/* Optional: Display selected items as tags below */}
       {/* <div className="mt-2 flex flex-wrap gap-1">
         {options
           .filter((opt) => selectedValues.includes(opt.value))
           .map((opt) => (
             <span
               key={opt.value}
               className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800"
             >
               {opt.label}
               <button
                 type="button"
                 className="ml-1 flex-shrink-0 text-indigo-400 hover:text-indigo-500 focus:outline-none focus:text-indigo-500"
                 onClick={(e) => removeSelectedValue(opt.value, e)}
               >
                 <FontAwesomeIcon icon={faTimes} className="h-3 w-3" />
               </button>
             </span>
           ))}
       </div> */}
    </div>
  );
};

export { CBMultiSelect };